import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { waLink } from "@/lib/whatsapp";
import { getContent } from "@/lib/cms";
import { LOGO_LIGHT_URL } from "@/lib/brand";
import { Leaf, Instagram, Facebook, Mail, MessageCircle, Lock, Store } from "lucide-react";

export function Footer() {
  const { settings } = useApp();
  const content = getContent(settings);
  const f = content.footer || {};
  const cols = f.columns || [];
  const copyright = (f.copyright || "© {year} LIVENEAT Organic. All rights reserved.").replace("{year}", new Date().getFullYear());
  return (
    <footer className="bg-forest text-cream mt-20">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
        <div className="col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src={LOGO_LIGHT_URL} alt="LIVENEAT logo" className="h-28 w-auto object-contain" />
          </div>
          <p className="text-sm text-cream/70 leading-relaxed max-w-xs">{f.about}</p>
          <div className="flex gap-3 mt-5">
            <a href={settings.instagram || "#"} className="w-9 h-9 rounded-full bg-cream/10 hover:bg-mustard hover:text-forest flex items-center justify-center transition-colors"><Instagram className="w-4 h-4" /></a>
            <a href={settings.facebook || "#"} className="w-9 h-9 rounded-full bg-cream/10 hover:bg-mustard hover:text-forest flex items-center justify-center transition-colors"><Facebook className="w-4 h-4" /></a>
            <a href={`mailto:${settings.email || ""}`} className="w-9 h-9 rounded-full bg-cream/10 hover:bg-mustard hover:text-forest flex items-center justify-center transition-colors"><Mail className="w-4 h-4" /></a>
            <a href={waLink(settings.whatsapp_number, "Hi LIVENEAT Organic!")} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-[#25D366] flex items-center justify-center"><MessageCircle className="w-4 h-4" /></a>
          </div>
        </div>
        {cols.map((c) => (
          <div key={c.title}>
            <h4 className="font-heading text-lg mb-4 text-mustard">{c.title}</h4>
            <ul className="space-y-2.5">
              {c.links.map(([label, to]) => (
                <li key={label}><Link to={to} className="text-sm text-cream/70 hover:text-cream transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-cream/10">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 py-5 flex flex-col gap-4">
          <div className="flex items-center justify-center gap-2.5" data-testid="footer-internal-logins">
            <Link to="/admin-login" data-testid="footer-admin-login" className="inline-flex items-center gap-1.5 rounded-full border border-cream/25 px-3.5 py-1.5 text-xs text-cream/75 hover:text-forest hover:bg-mustard hover:border-mustard transition-colors">
              <Lock className="w-3.5 h-3.5" /> Admin Login
            </Link>
            <Link to="/brand-login" data-testid="footer-brand-login" className="inline-flex items-center gap-1.5 rounded-full border border-cream/25 px-3.5 py-1.5 text-xs text-cream/75 hover:text-forest hover:bg-mustard hover:border-mustard transition-colors">
              <Store className="w-3.5 h-3.5" /> Brand Login
            </Link>
          </div>
          <div className="flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-cream/60">
            <p>{copyright}</p>
            <p>Live Well. Everyday.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
